import { alpha } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  500_12: alpha('#919EAB', 0.12),
  500_16: alpha('#919EAB', 0.16),
  500_24: alpha('#919EAB', 0.24),
  500_32: alpha('#919EAB', 0.32),
  500_48: alpha('#919EAB', 0.48),
  500_56: alpha('#919EAB', 0.56),
  500_8: alpha('#919EAB', 0.08),
  500_80: alpha('#919EAB', 0.8),
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const PRIMARY = {
  contrastText: '#fff',
  dark: '#007B55',
  darker: '#005249',
  light: '#5BE584',
  lighter: '#C8FACD',
  main: '#00AB55',
};
const SECONDARY = {
  contrastText: '#fff',
  dark: '#1939B7',
  darker: '#091A7A',
  light: '#84A9FF',
  lighter: '#D6E4FF',
  main: '#3366FF',
};
const INFO = {
  contrastText: '#fff',
  dark: '#0C53B7',
  darker: '#04297A',
  light: '#74CAFF',
  lighter: '#D0F2FF',
  main: '#1890FF',
};
const SUCCESS = {
  contrastText: GREY[800],
  dark: '#229A16',
  darker: '#08660D',
  light: '#AAF27F',
  lighter: '#E9FCD4',
  main: '#54D62C',
};
const WARNING = {
  contrastText: GREY[800],
  dark: '#B78103',
  darker: '#7A4F01',
  light: '#FFE16A',
  lighter: '#FFF7CD',
  main: '#FFC107',
};
const ERROR = {
  contrastText: '#fff',
  dark: '#B72136',
  darker: '#7A0C2E',
  light: '#FFA48D',
  lighter: '#FFE7D9',
  main: '#FF4842',
};

const GRADIENTS = {
  error: createGradient(ERROR.light, ERROR.main),
  info: createGradient(INFO.light, INFO.main),
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
};

const COMMON = {
  action: {
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    disabledOpacity: 0.48,
    focus: GREY[500_24],
    hover: GREY[500_8],
    hoverOpacity: 0.08,
    selected: GREY[500_16],
  },
  common: { black: '#000', white: '#fff' },
  divider: GREY[500_24],
  error: { ...ERROR },
  gradients: GRADIENTS,
  grey: GREY,
  info: { ...INFO },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  success: { ...SUCCESS },
  warning: { ...WARNING },
};

const palette = {
  dark: {
    ...COMMON,
    action: { active: GREY[500], ...COMMON.action },
    background: { default: GREY[900], neutral: GREY[500_16], paper: GREY[800] },
    text: { disabled: GREY[600], primary: '#fff', secondary: GREY[500] },
  },
  light: {
    ...COMMON,
    action: { active: GREY[600], ...COMMON.action },
    background: { default: '#fff', neutral: GREY[200], paper: '#fff' },
    text: { disabled: GREY[500], primary: GREY[800], secondary: GREY[600] },
  },
};

export default palette;
